import React from 'react';
import classnames from 'classnames';

import { ensureCurrencyIsPresent } from './util';
import StripeChargeModalIconRenderWrapper, {
  DesktopTooltipProps,
  IconProps,
  ModalProps,
  TooltipProps
} from './StripeChargeModalIconRenderWrapper';

interface StripeChargeModalPaymentSummaryLineItemV2Props {
  className?: string | null;
  amountInDollars: string;
  description: string;
  longDescription?: React.ReactNode | null;
  discountedPriceInDollars?: string | null;
  iconProps?: IconProps | null;
  itemType: string;
  tooltipProps?: TooltipProps | null;
  disableInteractions?: boolean;
  modalProps?: ModalProps | null;
  desktopTooltipProps?: DesktopTooltipProps | null;
}

export default function StripeChargeModalPaymentSummaryLineItemV2({
  className,
  amountInDollars,
  description,
  disableInteractions = false,
  discountedPriceInDollars = null,
  iconProps = null,
  itemType,
  longDescription = null,
  modalProps = null,
  tooltipProps = null,
  desktopTooltipProps = null
}: StripeChargeModalPaymentSummaryLineItemV2Props) {
  const amountWithCurrencySign = ensureCurrencyIsPresent(amountInDollars);
  const showIcon = iconProps != null && !disableInteractions;

  return (
    <>
      <div
        className={classnames(
          'StripeChargeModalPaymentSummaryLineItem font-14 md:font-16 flex pv6',
          className
        )}
      >
        <div className="flex-auto">
          <div className="inline-flex items-center gap-4">
            <span className="fw-medium">{description}</span>
            {showIcon && (
              <StripeChargeModalIconRenderWrapper
                iconProps={iconProps}
                tooltipProps={tooltipProps}
                modalProps={modalProps}
                desktopTooltipProps={desktopTooltipProps}
              />
            )}
          </div>
          {longDescription && (
            <p className="StripeChargeModalPaymentSummaryLineItem__description font-12 sm:font-16 secondary w-90-md">
              {longDescription}
            </p>
          )}
        </div>
        <p>
          {discountedPriceInDollars !== null && (
            <>
              <span className="strike secondary">
                {ensureCurrencyIsPresent(discountedPriceInDollars)}
              </span>
              &nbsp;&nbsp;
            </>
          )}
          <span
            className="StripeChargeModalPaymentSummaryLineItem__amount fw-medium"
            data-test-id={`StripeChargeModalPaymentSummaryLineItem-${itemType}-amount`}
          >
            {amountWithCurrencySign}
          </span>
        </p>
      </div>
    </>
  );
}
